import database from "../../services/database";


/**
 * Salvar uma nova configuração
 * @param document
 * @param value
 * @returns {Promise<void>}
 */
export function save(document, value){
    return database.collection('conf').doc(document).set({text: value});
}

/**
 * Busca os dados de uma configuração
 * @param document
 * @returns {Promise<*>}
 */
export async function get(document) {
    const queryDocument = await database.collection('conf').doc(document).get();
    if(queryDocument.exists){
        return queryDocument.data().text;
    }
    return null
}